module.exports = __webpack_public_path__ + "static/img/6-16.ef67ab1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/newsDetail/6-16.png
// module id = rvBZ
// module chunks = 1